import {
  Button,
  FloatingPanel as ChakraFloatingPanel,
  FloatingPanelContentProps,
  FloatingPanelHeaderProps,
  FloatingPanelRootProps,
  Portal,
} from '@chakra-ui/react'
import {ReactNode} from 'react'
import {LuX} from 'react-icons/lu'

export interface FloatingPanelProps extends FloatingPanelRootProps {
  contentProps?: FloatingPanelContentProps & {'data-e2e'?: string}
  headerProps?: FloatingPanelHeaderProps
  portalled?: boolean
  hideCloseButton?: boolean
  title?: ReactNode
}

export function FloatingPanel({
  children,
  contentProps,
  headerProps,
  portalled = true,
  hideCloseButton,
  title,
  ...props
}: FloatingPanelProps) {
  const internalProps: Partial<FloatingPanelRootProps> = {
    defaultSize: {width: 1100, height: 700},
  }
  if (props.id) internalProps.id = props.id

  return (
    <ChakraFloatingPanel.Root {...internalProps} {...props}>
      <Portal disabled={!portalled}>
        <ChakraFloatingPanel.Positioner>
          <ChakraFloatingPanel.Content {...contentProps}>
            <ChakraFloatingPanel.Header {...headerProps}>
              {title && <ChakraFloatingPanel.Title>{title}</ChakraFloatingPanel.Title>}
              {!hideCloseButton && (
                <ChakraFloatingPanel.CloseTrigger asChild>
                  <Button variant="plain" size="sm" position="absolute" right="2" top="4">
                    <LuX />
                  </Button>
                </ChakraFloatingPanel.CloseTrigger>
              )}
            </ChakraFloatingPanel.Header>

            <ChakraFloatingPanel.Body>{children}</ChakraFloatingPanel.Body>

            <ChakraFloatingPanel.ResizeTriggers axes={['n', 's', 'e', 'w', 'ne', 'nw', 'se', 'sw']} />
          </ChakraFloatingPanel.Content>
        </ChakraFloatingPanel.Positioner>
      </Portal>
    </ChakraFloatingPanel.Root>
  )
}
